import { useMutation } from '@apollo/client/react';
import { UPDATE_GROUP_MEMBERS } from '../queries/UpdateGroupMembers';
import { loggerService } from '@brainpool/logger';
import { LoggerContextProps } from '../types/LogContext';
import { LIST_GROUPS } from '../queries/ListGroups';
import { handleError } from './errorHandler';

export type GroupMemberAction = 'ADD' | 'REMOVE';

export interface UpdateGroupMembersInput {
  id: string;
  members: string[];
  action: GroupMemberAction;
}
export interface UpdateGroupMembersProps {
  groups: UpdateGroupMembersInput[];
  caseIds?: Array<{ case_id: string }>;
}
const context: LoggerContextProps = {
  action: 'updateGroupMembers',
};
export function useUpdateGroupMembers() {
  const [updateGroupMembersQuery, { data, loading, error }] = useMutation<{
    updateGroupMembers: {
      success: boolean;
    };
  }>(UPDATE_GROUP_MEMBERS, {});

  const updateGroupMembers = async ({ groups, caseIds }: UpdateGroupMembersProps) => {
    try {
      const result = await updateGroupMembersQuery({
        variables: { input: groups },
        refetchQueries: caseIds
          ? [
              {
                query: LIST_GROUPS,
                variables: {
                  filter: caseIds,
                  limit: 100,
                },
              },
            ]
          : [],
        awaitRefetchQueries: true,
      });

      if (result.data?.updateGroupMembers.success) {
        loggerService.log({
          message: `Group members updated successfully.`,
          logLevel: 'success',
          context,
          userMessage: { message: `Group members updated successfully.` },
        });
      }
    } catch (error) {
      handleError(error, context, 'Failed to update group members.');
    }
  };

  return { updateGroupMembers, data, loading, error };
}
